import isHybridEnabledCSR from './isHybridEnabledCSR'

export default isHybridEnabledCSR
